import { ServiceCategory } from "./categories";
import { ServiceHandle } from "./service-handle";

export class ProService {
  id: string;
  name: string;
  description: string;
  serviceCategoryId: string;
  validated: boolean;
  addressLine?: string;
  city: string;
  country: string;
  state: string;


  // sub_region: string;
  // cityId: string;
  // validatedName: string;
  serviceCategory: ServiceCategory;
  primaryContactNumber: string;
  serviceHandles: ServiceHandle[];
  address?: Address[];
  contactNos?: ContactNos[];

}

 export class Address {
  id:string;
  line: string;
  sub_region: string;
  cityId: string;
}

export class ContactNos {
  contactNos: string;
}

export interface Country {
  shortName: string;
  name: string;
}
